<div class="row">
    <div class="col-md-12">
        <div class="row modal_header" style="position: sticky;z-index: 999;top: 0;">
            <div class="col-9">
                <i class="fa fa-address-book"></i>
                <span class="ml-2">Sales Target</span>
            </div>
            <div class="col-3 text-right">
                <a style="cursor:pointer">
                    <i class="fa-solid fa-xmark" (click)="Close()" style="font-size: xx-large;"></i>
                </a>
            </div>
        </div>
        <div class="card card_content">
            <form [formGroup]="form">
                <div class="row d-flex justify-content-center">
                    <div class="col-9 mt-2">
                        <fieldset [disabled]="data?.id">
                            <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                                <mat-label>Target Month</mat-label>
                                <input readonly matInput  [matDatepicker]="effectiveFrom" id="effectiveFrom"
                                    formControlName="effectiveFrom" autocomplete="off" placeholder="Select Target Month"
                                    class="col-12 custom-input-border" specialIsAlphaNumeric
                                    (click)="FnmonthFilterPicker()" style="color:hsl(0, 0%, 0%);">
                                <mat-datepicker-toggle matSuffix [for]="effectiveFrom" style="color:black;">
                                    <button mat-icon-button>
                                        <mat-icon>event</mat-icon>
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                            stroke="currentColor">
                                        </svg>
                                    </button>
                                </mat-datepicker-toggle>
                                <mat-datepicker #effectiveFrom startView="multi-year"
                                    (monthSelected)="setMonthAndYear($event, effectiveFrom)"
                                    panelClass="example-month-picker">
                                </mat-datepicker>
                            </mat-form-field>
                        </fieldset>
                    </div>
                    <div class="col-9 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Service Provider</mat-label>
                            <mat-select class="scrollbarcs" formControlName="serviceProviderId"
                                [disabled]="!form.value.effectiveFrom || data?.id" placeholder="Select Service Provider"
                                (valueChange)="getvalue()">
                                <mat-select-filter [displayMember]="'value'" [array]="serviceProviderList"
                                    (filteredReturn)="filterserviceProviderList = $event"></mat-select-filter>
                                <mat-option *ngFor="let item of filterserviceProviderList" [value]="item.key"
                                    style="overflow-y: scroll !important;">
                                    {{item.value}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-9 mt-4" *ngIf="!checkForAll">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Target Count per Day</mat-label>
                            <input class="form-control" matInput type="text" id="targetDayCount"
                                (input)="onInputChangeNumber($event,'targetDayCount');onInput($event,'/^[0-9]*$/');dayvalidOnKeyUp()"
                                placeholder="Enter Day Count.." maxlength="5" formControlName="targetDayCount"
                                autocomplete="off" class="col-12">
                        </mat-form-field>
                    </div>
                    <div class="col-9 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Target Count per Month</mat-label>
                            <input class="form-control" matInput type="text" id="targetMonthCount"
                                (input)="onInputChangeNumber($event,'targetMonthCount');onInput($event,'/^[0-9]*$/');monthChange()"
                                placeholder="Enter Month Count.." maxlength="5" formControlName="targetMonthCount"
                                autocomplete="off" class="col-12">
                        </mat-form-field>
                    </div>
                    <div class="col-9 mt-4" *ngIf="checkForAll">
                        <fieldset [disabled]="disableYear">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Target Count per Year</mat-label>
                                <input class="form-control" matInput type="text" id="targetYearCount"
                                    placeholder="Enter Year Count.."
                                    (input)="onInputChangeNumber($event,'targetYearCount');onInput($event,'/^[0-9]*$/');yearvalidOnKeyUpForHC()"
                                    maxlength="10" formControlName="targetYearCount" autocomplete="off" class="col-12">
                            </mat-form-field>
                        </fieldset>
                    </div>
                </div>
                <div class="row col-lg-12 col-md-12 col-sm-12 col-xs-12" style="text-align:right;color:red">
                    <label *ngIf="validcheck === false">Please Enter Valid Count Details...</label>
                </div>
                <div class="row mt-4">
                    <div class="col-xl-12 text-center">
                        <button *ngIf="validcheck" [disabled]="form.invalid" class="btn btn-secondary mr-3"
                            (click)="Submit()">
                            Save
                        </button>
                        <button class="btn btn-primary" (click)="Close()">
                            Cancel
                        </button>
                    </div>
                </div>
                <div class="row mt-2" style="text-align:center;color:red;">
                    * Please note the service provider dropdown will show only the items that are not yet done for this
                    month.
                </div>
            </form>
        </div>
    </div>
</div>